// extracted by mini-css-extract-plugin
module.exports = {"hero-overlay-single-author":"hero-overlay-single-author-m__hero-overlay-single-author__vVq1B"};